import { JSX, ReactNode, createContext, useContext } from "react";

import { Exception } from "@tsp-core/exception";

import { SoulEntityCtx } from "./soul-entity-context.types";

const SoulEntityContext = createContext<SoulEntityCtx | undefined>(undefined);

export type SoulEntityContextProviderProps = SoulEntityCtx & {
  children: ReactNode;
};

function SoulEntityContextProvider(props: SoulEntityContextProviderProps): JSX.Element {
  const { children, ...rest } = props;

  return <SoulEntityContext.Provider value={rest}>{children}</SoulEntityContext.Provider>;
}

export function useSoulEntityContext(): SoulEntityCtx {
  const context = useContext(SoulEntityContext);
  if (!context) {
    throw new Exception(
      -1,
      "SoulEntityContext is not defined! Please check that you are using useSoulEntityContext in a child of SoulEntityContextProvider!",
      null,
    );
  }

  return context;
}

export { SoulEntityContextProvider };
